var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5C9.48 5 5 9.48 5 15C5 20.52 9.48 25 15 25C20.52 25 25 20.52 25 15C25 9.48 20.52 5 15 5ZM19 16H16V19C16 19.55 15.55 20 15 20C14.45 20 14 19.55 14 19V16H11C10.45 16 10 15.55 10 15C10 14.45 10.45 14 11 14H14V11C14 10.45 14.45 10 15 10C15.55 10 16 10.45 16 11V14H19C19.55 14 20 14.45 20 15C20 15.55 19.55 16 19 16Z",
    fill: "#C3CAD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMaster);
export default __webpack_public_path__ + "static/media/add-master.dce0cbe4ff0f3f9e06e488169312f22c.svg";
export { ForwardRef as ReactComponent };